import { AttachmentType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { Button } from '@mui/material';
import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { WriteWithAIFormValues } from '../../hooks/useWriteWithAIForm';
import { WriteWithAIOnSelectOptions } from '../../hooks/useWriteWithAI';

type WriteWithAIActionButtonsProps = {
  onGenerate: () => void;
  onSelect: (options: WriteWithAIOnSelectOptions) => void;
};

function WriteWithAIActionButtons({ onGenerate, onSelect }: WriteWithAIActionButtonsProps) {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<WriteWithAIFormValues>();
  const text = useWatch({
    control,
    name: 'text',
    defaultValue: [],
  });
  const lastPrompt = useMemo(() => text[text.length - 1], [text]);

  return (
    <>
      {!lastPrompt?.loading && !lastPrompt?.genAIResponse && (
        <Button disabled={isSubmitting} onClick={onGenerate} variant="contained">
          Create a Draft
        </Button>
      )}
      {lastPrompt?.genAIResponse && !lastPrompt?.isStreaming && (
        <Button
          disabled={isSubmitting}
          onClick={() =>
            onSelect({
              ...lastPrompt?.articleMetaData,
              embeddedAttachments: (lastPrompt.embeddedAttachments || []) as AttachmentType[],
            })
          }
          variant="contained"
        >
          Next
        </Button>
      )}
    </>
  );
}

export default WriteWithAIActionButtons;
